import { ProductId, Serializer } from "../../model/datasource";

export class SummaryFrontend<P extends ProductId> {
	productIdSerializer: Serializer<P>;

	constructor(item: Serializer<P>) {
		this.productIdSerializer = item;
	}

	getTable(): HTMLTableElement {
		return document.querySelector('.attempts table');
	}
}
